<template>
  <v-container class="pa-0">
    <v-data-table
      :headers="headers"
      :items="items"
      disable-pagination
      class="border"
      hide-default-footer
      density="compact"
    >
      <template
        v-slot:[`item.${header.value}`]="{ item }"
        v-for="header in headers"
      >
        <td :key="`${item.id}-${header.value}`">
          {{ formatValue(item[header.value]) }}
        </td>
      </template>
      <template v-slot:body.append>
        <tr
          class="border"
          :style="{
            backgroundColor: PAYMENT_CERTIFICATE_TABLE_COLOR.BLUE,
            fontWeight: 500,
          }"
        >
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="getColumnClass(index)"
          >
            {{
              header.total
                ? items === 'percent'
                  ? "N/A"
                  : formatValue(sumField(header.value, items))
                : index === lastTextIndex
                ? summaryText
                : ""
            }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {
  getColumnClass,
  formatValue,
  PAYMENT_CERTIFICATE_TABLE_COLOR
} from '@/helpers'

export default {
  props: {
    headers: Array,
    items: Array,
    summaryText: String
  },
  data () {
    return {
      getColumnClass,
      formatValue,
      PAYMENT_CERTIFICATE_TABLE_COLOR
    }
  },
  methods: {
    sumField (field, items) {
      const sum = items
        .filter(
          (item) =>
            item[field] !== 'N/A' &&
            item[field] !== '' &&
            !item.hasSubMilestones
        )
        .reduce((sum, item) => sum + parseFloat(item[field]), 0)

      if (field === 'percent') {
        return sum.toFixed(2) + ' %'
      }

      return sum
    }
  },
  computed: {
    lastTextIndex () {
      return this.headers.findIndex((header) => header.total) - 1
    }
  }
}
</script>
